import type { FaireProductEntity } from "../../entity_types/product";

export const p_xxpbgurgas: FaireProductEntity = {
  token: "p_xxpbgurgas",
  type: "product",
  name: "Organic Knit Booties - Brown",
  brandToken: "b_a1cy3tx6q8",
  brandName: "Harp Angel Boutique",
  imageUrl: "https://cdn.faire.com/fastly/4c14f65285d35368c0086311e4e5934f99c27d6ab18fa36664557adb5e07ed64.png",
  galleryImageUrls: [],
  priceDollars: 11,
  description: "\nOur brown organic knit booties are designed to keep little toes warm. Mindfully made with the finest quality organic cottons. Organic certification ensures the booties are gentle on your baby's delicate skin. Functional ties at the ankle ensure a secure fit. \n\n * Made of 100% certified organic cotton \n * Size 0-3+ months: measure 3.5” length \n * Ribbed knit cuffs \n * Ties for secure fit\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:19.228Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
